import React from 'react';
import { motion } from 'framer-motion';
import { Utensils, Wheat, GlassWater, Soup, Sandwich, PackagePlus, ShoppingCart } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/LanguageContext';
import { THUISBEZORGD_ORDER_URL } from '@/components/OrderModal';

const MenuPage = () => {
  const { t } = useLanguage();

  const menuData = {
    broodjes: [
      { name: t("menuPage.items.kipKerrieBroodje"), price: "€6,00" },
      { name: t("menuPage.items.kipKetjapBroodje"), price: "€6,00" },
      { name: t("menuPage.items.lamsBroodje"), price: "€6,00" },
      { name: t("menuPage.items.eiBroodje"), price: "€6,00" },
      { name: t("menuPage.items.garnalenKousebandBroodje"), price: "€6,00" },
      { name: t("menuPage.items.bakkeljauwBroodje"), price: "€6,00" },
      { name: t("menuPage.items.vegetarischBroodje"), price: "€6,00", description: t("menuPage.items.vegetarischBroodjeDesc") },
    ],
    nasiBamiWitteRijst: [
      { name: t("menuPage.items.vegetarischNasi"), price: "€13,00", description: t("menuPage.items.vegetarischNasiDesc") },
      { name: t("menuPage.items.kipsatePindasausNasi"), price: "€15,00" },
      { name: t("menuPage.items.kipfiletKerrieNasi"), price: "€15,00" },
      { name: t("menuPage.items.kipfiletKetjapNasi"), price: "€15,00" },
      { name: t("menuPage.items.lamsNasi"), price: "€16,00" },
      { name: t("menuPage.items.garnalenNasi"), price: "€16,00" },
    ],
    roti: [
      { name: t("menuPage.items.vegetarischRotiNormaal"), price: "€11,00", description: t("menuPage.items.vegetarischRotiNormaalDesc") },
      { name: t("menuPage.items.vegetarischRotiSpeciaal"), price: "€13,00", description: t("menuPage.items.vegetarischRotiSpeciaalDesc") },
      { name: t("menuPage.items.kipfiletKerrieRotiNormaal"), price: "€13,00", description: t("menuPage.items.kipfiletKerrieRotiNormaalDesc") },
      { name: t("menuPage.items.kipfiletKerrieRotiSpeciaal"), price: "€15,00", description: t("menuPage.items.kipfiletKerrieRotiSpeciaalDesc") },
      { name: t("menuPage.items.kipfiletKetjapRotiNormaal"), price: "€13,00", description: t("menuPage.items.kipfiletKetjapRotiNormaalDesc") },
      { name: t("menuPage.items.kipfiletKetjapRotiSpeciaal"), price: "€15,00", description: t("menuPage.items.kipfiletKetjapRotiSpeciaalDesc") },
      { name: t("menuPage.items.kipMetBotRotiNormaal"), price: "€13,00", description: t("menuPage.items.kipMetBotRotiNormaalDesc") },
      { name: t("menuPage.items.kipMetBotRotiSpeciaal"), price: "€15,00", description: t("menuPage.items.kipMetBotRotiSpeciaalDesc") },
      { name: t("menuPage.items.lamsRotiNormaal"), price: "€14,00", description: t("menuPage.items.lamsRotiNormaalDesc") },
      { name: t("menuPage.items.lamsRotiSpeciaal"), price: "€16,00", description: t("menuPage.items.lamsRotiSpeciaalDesc") },
    ],
    voorgerechtenEnSnacks: [
      { name: t("menuPage.items.baraSnack"), price: "€2,00" },
      { name: t("menuPage.items.bakbanaanSnack"), price: "€2,00" },
      { name: t("menuPage.items.bakbanaanPindasausSnack"), price: "€2,00" },
      { name: t("menuPage.items.teloBakkeljauwSnack"), price: "€6,00" },
      { name: t("menuPage.items.pitjelSnack"), price: "€6,00" },
      { name: t("menuPage.items.kipsatePindasausSnack"), price: "€6,00" },
      { name: t("menuPage.items.kipsateKetjapsausSnack"), price: "€6,00" },
      { name: t("menuPage.items.saotoSoepSnack"), price: "€6,00" },
      { name: t("menuPage.items.rotiRolKipSnack"), price: "€8,00" },
      { name: t("menuPage.items.rotiRolVegetarischSnack"), price: "€8,00" },
      { name: t("menuPage.items.rotiRolLamsSnack"), price: "€9,00" },
    ],
    extra: [
      { name: t("menuPage.items.losseRotiPlaatExtra"), price: "€2,00" },
      { name: t("menuPage.items.bakjePindasausExtra"), price: "€2,50" },
      { name: t("menuPage.items.bakjeKousebandExtra"), price: "€4,00" },
      { name: t("menuPage.items.bakjeAardappelExtra"), price: "€4,00" },
      { name: t("menuPage.items.bakjeWitteRijstExtra"), price: "€5,00" },
      { name: t("menuPage.items.bakjeNasiBamiExtra"), price: "€6,00" },
      { name: t("menuPage.items.bakjeKipfiletKerrieExtra"), price: "€12,00" },
      { name: t("menuPage.items.bakjeKipfiletKetjapExtra"), price: "€12,00" },
      { name: t("menuPage.items.bakjeLamsExtra"), price: "€16,00" },
    ],
    dranken: [
      { name: t("menuPage.items.colaDrank"), price: "€2,00" },
      { name: t("menuPage.items.fantaDrank"), price: "€2,00" },
      { name: t("menuPage.items.chocomelDrank"), price: "€2,00" },
      { name: t("menuPage.items.fernandesDrank"), price: "€2,50" },
      { name: t("menuPage.items.gemberBeerDrank"), price: "€2,50" },
      { name: t("menuPage.items.tropicalDrank"), price: "€2,50" },
      { name: t("menuPage.items.coconutJuiceDrank"), price: "€2,50" },
      { name: t("menuPage.items.waterDrank"), price: "€2,50" },
      { name: t("menuPage.items.mangoDrank"), price: "€2,50" },
    ]
  };


  const MenuItem = ({ name, price, description }) => (
    <motion.div 
      className="py-4 border-b border-gray-200 last:border-b-0"
      initial={{ opacity: 0, x: -20 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4 }}
    >
      <div className="flex justify-between items-start">
        <h4 className="text-lg font-semibold text-gray-800">{name}</h4>
        <p className="text-lg font-semibold brand-text whitespace-nowrap pl-4">{price}</p>
      </div>
      {description && <p className="text-sm text-muted-foreground mt-1">{description}</p>}
    </motion.div>
  );

  const MenuCategory = ({ title, items, icon }) => (
    <div className="mb-10">
      <div className="flex items-center mb-4">
        {icon && React.cloneElement(icon, { className: "h-6 w-6 brand-text mr-3" })}
        <h3 className="text-2xl font-bold text-gray-700">{title}</h3>
      </div>
      <div>
        {items.map((item, index) => (
          <MenuItem key={index} {...item} />
        ))}
      </div>
    </div>
  );
  
  return (
    <div className="py-12 md:py-20 bg-white pattern-bg">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-12 md:mb-16"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <img src="/images/amsfoodmarket-logo.png" alt="Ams Food Market Logo" className="h-24 mx-auto mb-6" />
          <h1 className="text-4xl md:text-5xl font-extrabold brand-text mb-4">{t('menuPage.title')}</h1>
          <div className="flex justify-center space-x-4 my-4">
            <span className="text-3xl md:text-4xl" role="img" aria-label="Indiase vlag">🇮🇳</span>
            <span className="text-3xl md:text-4xl" role="img" aria-label="Sri Lankaanse vlag">🇱🇰</span>
            <span className="text-3xl md:text-4xl" role="img" aria-label="Surinaamse vlag">🇸🇷</span>
          </div>
          <p 
            className="text-lg text-muted-foreground max-w-2xl mx-auto"
            dangerouslySetInnerHTML={{ __html: t('menuPage.subtitle') }}
          />
          <motion.div
            className="mt-8"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <Button 
              asChild
              size="lg" 
              className="primary-button"
            >
              <a href={THUISBEZORGD_ORDER_URL} target="_blank" rel="noopener noreferrer">
                <ShoppingCart className="mr-2 h-5 w-5" />
                {t('menuPage.orderButton')}
              </a>
            </Button>
          </motion.div>
        </motion.div>

        <div className="w-full">
          <MenuCategory title={t('menuPage.categories.broodjes')} items={menuData.broodjes} icon={<Sandwich />} />
          <MenuCategory title={t('menuPage.categories.nasiBamiWitteRijst')} items={menuData.nasiBamiWitteRijst} icon={<Utensils />} />
          <MenuCategory title={t('menuPage.categories.roti')} items={menuData.roti} icon={<Wheat />} />
          <MenuCategory title={t('menuPage.categories.voorgerechtenEnSnacks')} items={menuData.voorgerechtenEnSnacks} icon={<Soup />} />
          <MenuCategory title={t('menuPage.categories.extra')} items={menuData.extra} icon={<PackagePlus />} />
          <MenuCategory title={t('menuPage.categories.dranken')} items={menuData.dranken} icon={<GlassWater />} />
        </div>

        <motion.div 
          className="mt-16 text-center p-6 bg-secondary rounded-lg"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <h3 className="text-xl font-semibold text-gray-800 mb-2">{t('menuPage.allergiesTitle')}</h3>
          <p className="text-muted-foreground">
            {t('menuPage.allergiesText')}
          </p>
        </motion.div>
      </div>

    </div>
  );
};

export default MenuPage;